<template>
  <div class="appointment">
    <div class="wrapper">
      <div :class="['form']">
        <div class="title">
          <img src="@/assets/reservation/tiele01.png" alt="" />
        </div>
     <div class="form-wrapper">
          <div class="input">
          <div class="inline">
            <div class="input-item">
              <div class="code-wrapper">
                <select v-model="codeText">
                <option value="66">+66</option>
              </select>
              </div>
              <input
                type="text"
                maxlength="10"
                v-model="phone"
                placeholder="กรุณาใส่เบอร์มือถือ 10 หลัก"
              />
            </div>
          </div>
        </div>
        <Checkboxs @getCheckVal="getCheckVal" />
        <div class="submit" @click="submit">
          <img
            :src="require('@/assets/reservation/reservation01.png')"
            alt=""
          />
        </div>
     </div>
      </div>
      <div class="img-splitline" @click="slideTo3">
        <img src="@/assets/reservation/img_splitline.png" alt="">
      </div>
    </div>
    <Dialog ref="Dialog" v-if="dialogvisible" @handleClose="close">{{
      dialogMsg
    }}</Dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { appointmentAction } from "@/api/index";
import Checkboxs from "./Checkboxs";
import Dialog from "./Dialog";
export default {
  components: {
    Checkboxs,
    Dialog,
  },
  data() {
    return {
      subindex: 0,
      phone: "",
      form: {
        platform: "1",
        areacode: "66",
        status: 1,
        phone: "",
        utm_source: this.$route.query.utm_source,
        utm_campaign: this.$route.query.utm_campaign,
        utm_medium: this.$route.query.utm_medium,
      },
      dialogMsg: "",
      codeText: "66",
      dialogvisible: false,
      radio: require("@/assets/reservation/radio.png"),
      radioOn: require("@/assets/reservation/radio_on.png"),

      clientWidth: document.body.clientWidth,
      agreementCheck: false,
      title: "",
      success: false,
      checkBoxVal: [],
      radioData: [
        {
          title: "Google Play",
          value: "1",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      navIndex: (state) => state.nav.navIndex,
    }),
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    document.addEventListener("mouseup", () => {
      let Dialog = this.$refs.Dialog;
      if (Dialog) {
        this.dialogvisible = false;
      }
    });
  },
  destroyed() {
    window.removeEventListener("resize");
  },
  methods: {
    getCheckVal(val) {
      this.checkBoxVal = val;
    },
    checkBoxChange(index) {
      this.checkBox[index] = !this.checkBox[index];
      this.$forceUpdate();
    },
    radioClick(item, index) {
      this.subindex = index;
      this.form.platform = item.value;
    },
    handleResize() {
      this.clientWidth = document.documentElement.clientWidth;
    },
    close() {
      this.dialogvisible = false;
    },
    tag(event) {
      window.gtag("event", "conversion", {
        send_to: "AW-10796958810/L9wTCILCsbcDENqIspwo",
        value: 1.0,
        currency: "USD",
      });
      window.fbq("track", event, {
        value: 1.0,
        currency: "USD",
      });
      window.gtag("event", event);
    },
    slideTo3() {
      this.$emit("fullPageSlide", 2);
    },
    async submit() {
      
      // let reg = this.codeText === "010" ? /^010\d{8}$/ : /^017\d{8}$/;
      let reg = /^\d{10}$/;
      if (reg.test(this.phone)) {
        if (this.checkBoxVal.length === 2) {
          this.form.phone = this.phone;
          this.form.areacode = this.codeText;
          this.form.utm_source = this.$route.query.utm_source;
          this.form.utm_campaign = this.$route.query.utm_campaign;
          this.form.utm_medium = this.$route.query.utm_medium;
          try {
            const result = await appointmentAction(this.form);
            console.log(result)
            if (result.status === 201) {
              window.fbq("track", "CompleteRegistration", {
                value: 1.0,
                currency: "USD",
              });
              window.gtag("event", "CompleteRegistration");
              window.gtag("event", "conversion", {
                send_to: "AW-10796958810/L9wTCILCsbcDENqIspwo",
                value: 1.0,
                currency: "USD",
              });
              this.dialogvisible = true;
              this.dialogMsg = "ลงทะเบียนสำเร็จ!";
            }else{
              this.dialogvisible = true;
              this.dialogMsg = result.detail;
            }
          } catch (error) {
            if (error.response.status === 404) {
              this.dialogvisible = true;
              this.dialogMsg = error.response.data.detail;
            }
          }
        } else {
          this.$message.error("กรุณายอมรับเงื่อนไข");
        }
      } else {
        this.$message.error("กรุณาใส่เบอร์โทรศัพท์อีกครั้ง");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.appointment {
  width: 100%;
  height: 100vh;
  background-image: url("~@/assets/reservation/bg_01.jpg");
  background-size: cover;
  position: relative;
  overflow: hidden;
  .form-wrapper{
    background: url("~@/assets/reservation/formBg-pc.png") no-repeat bottom right / cover;
    padding: 6.9rem 7.5rem;
    box-sizing: border-box;
    position: relative;
    margin: 0 auto;
    width: 105.3rem;
     border: 1px solid rgba(191, 156, 80, .48);
     @media only screen and (max-width: 1400px) {
       padding: 3rem 4rem;
       width: 54.8%;
     }
      @media only screen and (max-width: 1024px) {
        width: 65.8%;
      }
     @media only screen and (max-width: 768px) {
        background: url("~@/assets/reservation/formBg.png") no-repeat bottom right / cover;
        // border: 1px solid rgba(191, 156, 80, .48);
        width: 100%;
        
     }
      @media only screen and (max-width: 420px) {
        padding: 1.5rem 2rem;
      }
     .input-item{
      //  background: url("~@/assets/reservation/inputbox_number.png") no-repeat top left / contain;
       height: 98px;
       @media only screen and (max-width: 768px) {
        height: 6rem;
      }
     }
  }
  .wrapper {
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: right;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media only screen and (max-width: 1024px) {
      background: none;
    }
    .form {
      color: #f7f6f6;
      width: 100%;
      @media only screen and (max-width: 1024px) {
        width: 90%;
        margin: 0 auto;
        height: 100%;
        margin-top: 8vh;
      }
      .title {
        margin-bottom: 2%;
        margin-top: -8%;
        img{
          max-width: 91.6rem;
          width: 100%;
          height: auto;
        }
            @media only screen and (max-width: 1024px) {
              img{
                max-width: unset;
              }
            }
        @media only screen and (max-width: 1024px) {
          width: 100%;
          margin-top: 0;
          margin-bottom: 3vh;
          // img {
          //   width: 50%;
          // }
        }
      }
      .radio {
        display: flex;
        align-items: center;
        grid-gap: 20px;
        width: 100%;
        margin-bottom: 3vh;
        @media only screen and (max-width: 1024px) {
          align-items: flex-start;
          grid-gap: 20px;
        }
        .inline {
          display: flex;
          align-items: center;
          grid-gap: 15px;
          @media only screen and (max-width: 1024px) {
            flex-direction: column;
            align-items: flex-start;
            grid-gap: 0;
          }
          .label {
            font-size: 25px;
            @media only screen and (max-width: 1024px) {
              font-size: 16px;
              margin-bottom: 2vh;
            }
          }
          .radios {
            display: flex;
            grid-gap: 15px;
            .radios-item {
              font-size: 25px;
              display: flex;
              align-items: center;
              grid-gap: 10px;
              cursor: pointer;
              @media only screen and (max-width: 1024px) {
                font-size: 16px;
              }
            }
          }
        }
      }
      .input {
        display: flex;
        align-items: flex-start;
        width: 100%;
        .inline {
          width: 100%;
          @media only screen and (max-width: 1024px) {
            width: 100%;
          }
          .label {
            font-size: 25px;
            margin: 3vh 0;
            @media only screen and (max-width: 1024px) {
              font-size: 16px;
            }
          }
        }
        &-item {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 48px;
          color: red;
          background: url("~@/assets/reservation/inputbox_number.png") no-repeat left center / contain;
          @media only screen and (max-width: 1024px) {
          }
          .code-wrapper{
            position: relative;
            width: 17%;
            text-align: left;
            height: 9.8rem;
            line-height: 9.8rem;
            // background: url("~@/assets/reservation/selectBg.png") no-repeat -0.9rem center / cover;
            &:after{
              content: '';
              border: 3px solid #A89E7C;
              border-left: none;
              border-top: none;
              width: 1.2rem;
              height: 1.2rem;
              transform: rotate(45deg);
              -webkit-transform: rotate(45deg);
              -moz-transform: rotate(45deg);
              -ms-transform: rotate(45deg);
              display: inline-block;
              position: absolute;
              right: 2rem;
              top: 37%;
            }
            @media only screen and (max-width: 1400px) {
              height: 6rem;
              line-height: 6rem;
              &:after{
                width: .5rem;
                height: .5rem;
                right: 1.5rem;
                top: 43%;
              }
            }
            @media only screen and (max-width: 768px) {
              background-position: right center;
              background-size: contain;
              &:after{
                right: 1.5rem;
              }
             }
          }
          select {
            outline: none;
            // height: 45px;
            margin-left: 3rem;
            color: #9EA8B5;
            font-weight: bold;
            border-radius: 4px;
            font-size: 2.6rem;
            text-align: center;
            border: 1px solid transparent;
            background: none;
            appearance: none;
            -webkit-appearance: none;
               @media only screen and (max-width: 1400px) {
                 font-size: 1.5rem;
               }
            @media only screen and (max-width: 1024px) {
              font-size: 12px;
              // margin-bottom: 10px;
              height: 30px;
              // width: 30%;
            }
             @media only screen and (max-width: 768px) {
              margin-left: 0
            
             }
          }
          input {
            flex: 1;
            height: 9.8rem;
            font-size: 2.2rem;
            border-radius: 4px;
            padding: 0 1rem;
            letter-spacing: 1px;
            outline: none;
            border: 1px solid transparent;
            background: none;
            font-weight: bold;
            color: rgba(255,255,255, .40);
            // background: url("~@/assets/reservation/inputBg.png") no-repeat -7px center / contain;
               @media only screen and (max-width: 1400px) {
                 height: 6rem;
                 font-size: 1.5rem;
               }
            @media only screen and (max-width: 1024px) {
              font-size: 12px;
              // width: 80%;
              // height: 30px;
            }
                  @media only screen and (max-width: 768px) {
                    background-size: -0.1rem center;
                    background-size: cover
                  }
          }
        }
      }
      .submit {
        margin: 0 auto;
        width: 260px;
        cursor: pointer;
        img{
          width: 100%;
          height: auto;
        }
        @media only screen and (max-width: 1024px) {
          text-align: left;
          margin: 2vh 0;
          // img {
          //   width: 50%;
          // }
        }
          @media only screen and (max-width: 1024px) {
            img{
              height: 4rem;
              width: auto;
            }
          }
      }
      .prize {
        width: 100%;
        @media only screen and (max-width: 1024px) {
          text-align: left;
          margin: 2vh 0;
          img {
            width: 100%;
          }
        }
      }
    }
    .img-splitline {
      margin-top: 2rem;
      cursor: pointer;
    }
  }
}
</style>
